import React, { useState, useEffect } from "react";
import footerBgImage from "../assets/FooterImg.png";

const FooterIllus: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 620);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 620);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleRequestQuote = () => {
    scrollToSection("contact");
  };

  return (
    <section
      style={{
        width: "100%",
        minHeight: "400px",
        background: `url(${footerBgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(45deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 100%)",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 10,
          paddingTop: "32px",
          paddingBottom: isMobile ? "60px" : "80px",
          paddingLeft: isMobile ? "16px" : "40px",
          paddingRight: isMobile ? "16px" : "40px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          justifyContent: "flex-start",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "28px" : "36px",
            fontWeight: "bold",
            color: "#ffffff",
            lineHeight: "1.3",
            marginBottom: "32px",
            margin: "0 0 32px 0",
            textAlign: "left",
            textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            maxWidth: isMobile ? "100%" : "600px",
          }}
        >
          Are you ready to move your products smarter, faster, and more efficiently across borders
          and cities?
        </h2>

        <button
          onClick={handleRequestQuote}
          style={{
            backgroundColor: "#04EEAD",
            border: "none",
            padding: "24px",
            borderRadius: "25px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "16px",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(4, 238, 173, 0.3)",
            height: "48px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 6px 20px rgba(4, 238, 173, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(4, 238, 173, 0.3)";
          }}
        >
          <span
            style={{
              color: "#1F2937",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
            }}
          >
            Request a Quote
          </span>
        </button>
      </div>
    </section>
  );
};

export default FooterIllus;